/* =============================================================================
   Collection filter tabs
   ============================================================================= */
(function () {
  'use strict';

  const tabs   = document.querySelectorAll('.collection-tabs__btn');
  const groups = document.querySelectorAll('.collection-group');
  const cards  = document.querySelectorAll('.product-card');

  if (!tabs.length) return;

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      const filter = tab.dataset.filter;

      // Update tab state
      tabs.forEach(t => { t.classList.remove('is-active'); t.setAttribute('aria-selected','false'); });
      tab.classList.add('is-active');
      tab.setAttribute('aria-selected','true');

      if (groups.length) {
        // Grouped (all-products) — show/hide groups
        groups.forEach(group => {
          const show = filter === 'all' || group.dataset.group === filter;
          group.style.display = show ? '' : 'none';
        });
      } else {
        // Flat grid — show/hide cards by type
        cards.forEach(card => {
          const type = card.dataset.type || '';
          const show = filter === 'all' || type === filter;
          card.style.display = show ? '' : 'none';
        });
      }
    });
  });

  // Sort select
  const sortSelect = document.getElementById('sort-select');
  if (sortSelect) {
    sortSelect.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }
})();
